export function preloadAssets(urls: readonly string[]) {
  urls.forEach((src) => {
    const link = document.createElement('link');

    link.rel = 'prefetch';
    link.href = src;

    if (src.endsWith('.mp4')) {
      link.as = 'video';
      link.type = 'video/mp4';
    } else if (src.endsWith('.webm')) {
      link.as = 'video';
      link.type = 'video/webm';
    } else {
      link.as = 'image';
    }

    document.head.appendChild(link);
  });
}
